export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'grdZakazkaSN';

export const NAME = 'ServisniPaket';

export enum PAKET_STATUS {
	NEIMPLEMENTOVANO = -9,
	NEODEPSATELNY_PAKET = -4,
	PAKET_NEEXISTUJE_V_KD = -3,
	CNB_NEVRATILA_CAP = -2,
	CHYBA_VYHODNOCENI = -1,
	PRIPRAVEN_K_REALIZACI = 1,
	ROZPRACOVANY_PAKET = 2,
	REALIZACE_UKONCENA = 3,
	NUTNO_EDITOVAT_CJ_U_PP = 4,
}

export enum ND_STATUS {
	NEIMPLEMENTOVANO = -9,
	NENAMAPOVANY_VM = -3,
	NEPLATNY_ND = -2,
	CHYBA_VYHODNOCENI = -1,
	PAKET_BEZ_ND = 0,
	CASTECNE_VYDANE_ND = 3,
	ND_VYDANY = 4,
	ND_NEJSOU_V_JFND = 5,
	ND_CASTECNE_V_JFND = 6,
	ND_CEKAJI_V_JFND = 7,
}

export enum PP_STATUS {
	NEIMPLEMENTOVANO = -9,
	NEPLATNA_PP = -2,
	CHYBA_VYHODNOCENI = -1,
	PAKET_BEZ_PP = 0,
	CASTECNE_ODEPSANE_PP = 2,
	PP_ODEPSANY = 3,
	PP_NEODEPSANY = 4,
	PP_BEZ_ZADANYCH_CJ = 5,
}
